import type { StatsSnapshot } from './gameplay-snapshot';
import { unitStats as stats } from './index';

export const updateCongressStats = (state: StatsSnapshot) => {
  const congress = state.generators.congress;

  const generatedGuilds = congress.owned * congress.baseGeneration;

  stats.congress = {
    buildingsGeneration: generatedGuilds,
  };
};
